import { SVG } from './SVG';
const IconDistance = () => {
  return (
    <SVG width="80" height="80" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.3897 62.6736C10.4926 62.6736 0 73.1662 0 86.0635C0 92.5838 3.56516 100.459 10.5967 109.471C15.6189 115.907 20.5821 120.561 20.7911 120.756L23.39 123.183L25.9889 120.756C26.1978 120.561 31.1611 115.907 36.1832 109.471C43.2145 100.459 46.7799 92.5838 46.7799 86.0635C46.7797 73.1662 36.287 62.6736 23.3897 62.6736ZM23.4004 112.603C21.6068 110.736 19.1 107.988 16.6011 104.785C10.7232 97.2518 7.61624 90.7777 7.61624 86.0635C7.61624 77.3661 14.6922 70.2901 23.3897 70.2901C32.0872 70.2901 39.1634 77.3658 39.1634 86.0635C39.1634 94.4688 29.4015 106.372 23.4004 112.603Z"
        fill="#4062BB"
      />
      <path
        d="M23.3902 78.4963C19.2178 78.4963 15.8232 81.8909 15.8232 86.0633C15.8232 90.2358 19.2178 93.6303 23.3902 93.6303C27.5627 93.6303 30.9572 90.2358 30.9572 86.0633C30.9572 81.8909 27.5627 78.4963 23.3902 78.4963Z"
        fill="#4062BB"
      />
      <path
        d="M106.61 6.81763C93.7133 6.81763 83.2207 17.3103 83.2207 30.2073C83.2207 36.7276 86.7859 44.6028 93.8172 53.6143C98.8391 60.0505 103.803 64.7048 104.011 64.8998L106.61 67.3263L109.209 64.8998C109.418 64.7048 114.381 60.0505 119.403 53.6143C126.435 44.6028 130 36.7276 130 30.2073C130 17.3105 119.508 6.81763 106.61 6.81763ZM106.61 56.7578C100.61 50.53 90.8369 38.6174 90.8369 30.2073C90.8369 21.5099 97.9129 14.4339 106.61 14.4339C115.308 14.4339 122.384 21.5099 122.384 30.2073C122.384 38.6177 112.611 50.53 106.61 56.7578Z"
        fill="#4062BB"
      />
      <path
        d="M106.61 22.6406C102.438 22.6406 99.043 26.0352 99.043 30.2076C99.043 34.38 102.438 37.7746 106.61 37.7746C110.783 37.7746 114.177 34.38 114.177 30.2076C114.177 26.0352 110.783 22.6406 106.61 22.6406Z"
        fill="#4062BB"
      />
      <path
        d="M92.646 86.2363H71.347C65.7467 86.2363 61.191 81.6805 61.191 76.0806C61.191 70.4806 65.7467 65.9248 71.347 65.9248H91.3764V58.3086H71.347C61.5474 58.3086 53.5747 66.281 53.5747 76.0806C53.5747 85.8801 61.5474 93.8525 71.347 93.8525H92.646C98.246 93.8525 102.802 98.4083 102.802 104.008C102.802 109.608 98.246 114.164 92.646 114.164H38.623V121.78H92.646C102.446 121.78 110.418 113.808 110.418 104.008C110.418 94.2087 102.446 86.2363 92.646 86.2363Z"
        fill="#4062BB"
      />
    </SVG>
  );
};

export { IconDistance as default, IconDistance };
